import React from 'react';
import { Flex, Typography, Button } from '../common';
import SettingsNavigateItem from '../common/SettingsNavigateItem';
import { TYPOGRAPHY } from '../../constants';
import { Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../theme/GlobalTheme';

function AccountSettings() {
  const navigate = useNavigate();
  const { isDark } = useThemeContext();
  return (
    <>
      <Flex
        vertical
        className="h-full min-h-[calc(100vh-12rem)] justify-between"
      >
        <Flex vertical className="pt-10 gap-6">
          <Typography text="Account Settings" type={TYPOGRAPHY.TITLE} />
          <SettingsNavigateItem
            props={{
              title: 'Password Management',
              to: '/settings/account-settings/password-management',
            }}
          />
          <Flex
            className="border-[2px] border-purple-600 rounded-md py-3 px-4 cursor-pointer max-w-96"
            onClick={() => {
              navigate(`${props?.to}`);
            }}
            justify="space-between"
            align="center"
          >
            <Typography
              text="Promotions"
              type={TYPOGRAPHY.SUBTITLE}
              className="!font-bold"
            />
            <Switch />
          </Flex>
        </Flex>
        <Flex vertical justify="space-between" className="w-full text-white">
          <Flex
            justify="end"
            className={`sticky bottom-0 w-full lg:justify-between justify-end p-4 border-t h-[56px] md:h-[72px] border-[#7C30F7] ${
              isDark ? 'bg-primaryDark' : 'bg-primaryLight'
            } `}
          >
            <Button
              text="Back"
              onClick={() => {
                navigate(-1);
              }}
              buttonProps={{ type: 'primary-none' }}
            />
            <Button text="Save" buttonProps={{ type: 'primary-square' }} />
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}

export default AccountSettings;
